// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// export default function IEM() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Industrial Entrepreneur Memorandum (IEM)</h1>

//                                   <h2>(1) What is an IEM (Industrial Entrepreneur Memorandum)?</h2>
//                                   <p>Industrial companies that are exempt from the trade license requirement of Industry (Development and Regulation) under Act I (D&R), 1951, must provide information related to the settlement of industries. as IEM (Industrial Entrepreneur Memorandum) Confirmation of receipt of such information by this department is referred to as "IEM Confirmation". The acknowledgement (Ack.) Of the IEM, which is given at the point with prima facie evidence of failure to comply with the license provisions, can therefore not be interpreted as a permit or authorization to carry out a commercial activity foreseen in the IEM, unless the provisions of the laws / Regulations / notices etc. issued from time to time by the central or state government or a specific address or suspension orders of the court / competent authority relevant to this activity will also be fully or in no way complied with hurt, as may be the case. Archived online by submitting details according to IEM 'Part A' via the G2B portal.</p>
                                 

//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                    <h2>(2) Do all industries have to submit IEM?</h2>
//                                   <p>All industrial companies are exempt from the industrial permit requirement under the I (D&R) Act, 1951 and investments in machinery and equipment of 50 million rupees or more; and sales of Rs 250 crore or more, including Existing Units, New Company (NU), and New Items (NA), can file an IEM, i.e., “Form IEM” in the prescribed format “Part A”. Press release of March 30, 2021 from GDP on the update of the paperless process for the IEM concession is now available.</p>

//                                   <h2>(3) whether the receipt will be issued after successful submission of 'Part A’ of IEM</h2>
//                                 <p>All online applications submitted via the portal will be checked in the 'IEM section' for verification in relation to the 'Certificate of Incorporation'; "Article Memorandum"; 'Bylaws',' Master Data ',' PAN 'and' Codes related to NIC and Ministry / Administrative Department etc. Once the above has been verified and found to be correct; The department issues IEM Ack electronically. to the applicant.</p>

//                                   <h2>(4) What is part B?</h2>
//                                   <p>All industrial companies that have submitted to IEM are obliged to report the start of commercial production and this is also archived online in the same portal by submitting information according to the mandatory form "Part B" of the IEM after the start of commercial production by the company; A copy of the associated IEM attestation is required when submitting this information to the portal. of the IEM, the department also gives Ack. for 'Part B' through its portal.</p>

//                                   <h2>(5) What is a change / addition?</h2>
//                                   <p>No changes / modifications will be made to IEMs submitted before June 30, 1998, with the exception of typographical errors. It was decided that the IEM in the new form, which came into effect on July 1, 1998 and was announced by Press Release No. 4 (1998 series) dated 15.98, will be changed / modified at the request of business people. on the conditions of press release No. 17 (1997 series) of November 27, 1997 with reference to the respectively issued statutes / ordinances / notifications of the federal and state governments.</p>
//                                   <p>Application for the IEM’s (Part A and Part B) and changes can be submitted online on this portal. To know more click here.</p>
//                                   <p>Disclaimer: This information is only for the purpose of the applicant when submitting the IEM application and cannot be used for any other purpose.</p>

//                                   <h2>At Apex Services What We Do</h2>
//                                   <p>Industrial Entrepreneur Memorandum is an undertaking needed for the acknowledgement of the beginning of commercial production. At Apex Professional Services, our experts will help in the filing of the IEM application, needed to be in the prescribed format. Once the application is filed, right from the generation of Receipt of Acknowledgement to getting it informed to the Director of Industries, we conduct it all.</p>

//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaCogs,
  FaFileAlt,
  FaList,
  FaRocket,
  FaFileInvoice,
  FaHandsHelping
} from "react-icons/fa";

export default function IEM() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                Industrial Entrepreneur Memorandum (IEM)
              </h1>

              <p>
                The Industrial Entrepreneur Memorandum (IEM) is a declaration
                filed by industrial units that are exempt from industrial
                licensing under the Industries (Development & Regulation) Act, 1951.
                It enables businesses to set up and operate manufacturing units
                while maintaining compliance with government regulations.
              </p>

              <p>
                IEM acts as an official intimation to the Government regarding
                industrial activities such as new projects, expansion, or diversification.
                It helps authorities track industrial growth while allowing businesses
                to operate without complex licensing procedures.
              </p>
            </Col>

            {/* RIGHT SIDE (YOU CAN ADD YOUR ASSISTANCE HERE LATER) */}
            <Col lg={4}>
              {/* Keep empty or add your assistance later */}
            </Col>

          </Row>

          {/* OBJECTIVES */}
          <h2 className="section-title">
            <FaList className="icon" /> Key Objectives of IEM
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Ensure compliance with industrial regulations</li>
            <li><FaCheckCircle /> Promote ease of doing business</li>
            <li><FaCheckCircle /> Monitor industrial growth and investments</li>
            <li><FaCheckCircle /> Support government policy-making</li>
            <li><FaCheckCircle /> Maintain transparency in industrial activities</li>
          </ul>

          {/* COMPONENTS */}
          <h2 className="section-title">
            <FaCogs className="icon" /> Main Components of IEM
          </h2>

          <h5><FaFileAlt className="sub-icon" /> Part A (Pre-Establishment)</h5>
          <p>
            Part A is filed before the commencement of the industrial project.
            It includes details such as company information, proposed activity,
            location of the unit, and investment details. After submission,
            authorities verify the information and issue an acknowledgment.
          </p>

          <h5><FaFileAlt className="sub-icon" /> Part B (Post-Production)</h5>
          <p>
            Part B is filed after the start of commercial production. It confirms
            that the industrial unit has become operational and is mandatory for
            all applicants who have filed Part A.
          </p>

          <h5><FaFileAlt className="sub-icon" /> Amendments</h5>
          <p>
            Amendments are required when there are changes in product line,
            location, investment, or company structure. Proper updates ensure
            compliance with regulatory requirements.
          </p>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaList className="icon" /> IEM Filing Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Prepare company and project details</li>
            <li><FaCheckCircle /> Submit Part A through the official portal</li>
            <li><FaCheckCircle /> Verification by government authorities</li>
            <li><FaCheckCircle /> Receive IEM acknowledgment</li>
            <li><FaCheckCircle /> File Part B after production begins</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of IEM
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> No requirement of industrial license</li>
            <li><FaCheckCircle /> Simple and hassle-free compliance</li>
            <li><FaCheckCircle /> Encourages industrial growth</li>
            <li><FaCheckCircle /> Improves business credibility</li>
            <li><FaCheckCircle /> Enables smooth government interaction</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileInvoice className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Certificate of Incorporation</li>
            <li><FaCheckCircle /> PAN Card</li>
            <li><FaCheckCircle /> MOA & AOA</li>
            <li><FaCheckCircle /> Project Report</li>
            <li><FaCheckCircle /> NIC Code Details</li>
            <li><FaCheckCircle /> Digital Signature Certificate</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support for IEM filing,
            including documentation preparation, NIC code classification,
            application submission, and follow-ups with authorities. Our team
            ensures a smooth, fast, and error-free process so you can focus on
            your business growth without compliance hassles.
          </p>

        </Container>
      </section>
    </div>
  );
}